"use client";
import { useMemo } from "react";
import { ConnectWalletScreen, CommonSubHeader } from "../../components";
import { usePathname, useRouter } from "next/navigation";
import { useCustomWallet } from "../../components/providers";

export default function BorrowLayout({
  children,
}: {
  children: React.ReactNode;
}): JSX.Element {
  const { isConnected } = useCustomWallet();
  const pathname = usePathname();
  const router = useRouter();

  const { isBackButtonActive, title, subtitle } = useMemo(() => {
    const isCreateLoan = pathname.includes("create-loan");
    const isBorrowMore = pathname.includes("borrow-more");
    const isManageLoan = pathname.includes("manage-loan");
    const isAddNfts = pathname.includes("add-nfts");

    return {
      isBackButtonActive:
        isCreateLoan || isBorrowMore || isManageLoan || isAddNfts,
      title: isBorrowMore
        ? "Borrow More"
        : isManageLoan
        ? "Manage Loan"
        : isAddNfts
        ? "Add NFTs"
        : "Borrow",
      subtitle: isAddNfts
        ? "Select assets to add as collateral to your loan"
        : isManageLoan
        ? "Remove assets from your loan and/or repay debt"
        : isBorrowMore
        ? "Borrow more and optionally add NFTs"
        : "Instant, open-ended loans using your RWAs",
    };
  }, [pathname]);

  const handleBackButtonClick = () => router.push("/borrow");

  return (
    <>
      <main className="relative mx-4 pb-16">
        <CommonSubHeader>
          {isBackButtonActive && (
            <CommonSubHeader.BackButton onClick={handleBackButtonClick} />
          )}
          <CommonSubHeader.SubHeaderH1>{title}</CommonSubHeader.SubHeaderH1>
          <CommonSubHeader.SubHeaderH2>{subtitle}</CommonSubHeader.SubHeaderH2>
        </CommonSubHeader>
        {isConnected === false ? (
          <ConnectWalletScreen className="mx-auto mt-14 my-10" />
        ) : (
          children
        )}
      </main>
    </>
  );
}
